import { render, staticRenderFns } from "./PcsCharts.vue?vue&type=template&id=38b32012&scoped=true"
import script from "./PcsCharts.vue?vue&type=script&lang=js"
export * from "./PcsCharts.vue?vue&type=script&lang=js"
import style0 from "./PcsCharts.vue?vue&type=style&index=0&id=38b32012&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b32012",
  null
  
)

export default component.exports